// Product Card Swiper Initialization
document.addEventListener('DOMContentLoaded', function() {
  initializeProductCardSwipers();
});

// Also initialize when new content is loaded (for dynamic content)
document.addEventListener('shopify:section:load', function(event) {
  if (event.target.querySelector('.product-card__swiper')) {
    initializeProductCardSwipers();
  }
});

function initializeProductCardSwipers() {
  const swiperContainers = document.querySelectorAll('.product-card__swiper');
  
  swiperContainers.forEach(container => {
    const productId = container.getAttribute('data-product-id');
    const prevButton = document.querySelector(`.product-card__swiper-prev[data-product-id="${productId}"]`);
    const nextButton = document.querySelector(`.product-card__swiper-next[data-product-id="${productId}"]`);
    
    
    // Check if Swiper is already initialized
    if (container.swiper) {
      return;
    }
    
    // Initialize Swiper
    const swiper = new Swiper(container, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      allowTouchMove: true,
      grabCursor: true,
      autoplay: false,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      breakpoints: {
        768: {
          allowTouchMove: true,
        }
      },
      on: {
        init: function() {
          // Hide navigation if only one slide
          if (this.slides.length <= 1) {
            if (prevButton) prevButton.style.display = 'none';
            if (nextButton) nextButton.style.display = 'none';
            
          }
        }
      }
    });
    
    // Store swiper instance on the container
    container.swiper = swiper;
  });
}

// Handle dynamic content loading (for infinite scroll, etc.)
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1 && node.querySelector && node.querySelector('.product-card__swiper')) {
          initializeProductCardSwipers();
        }
      });
    }
  });
});

// Start observing
observer.observe(document.body, {
  childList: true,
  subtree: true
}); 